// Yup
import * as yup from 'yup';

// Helpers
import Helpers from '.';


const createValidationSchema = (schemas: any) => {
    const rules = ['email', 'password', 'phone'];
    let validationSchema: any = {};

    schemas.findIndex((index: string) => {
        if (index === 'email') {
            validationSchema['email'] = yup
                .string()
                .email(Helpers.translation('email_input_valid_error'))
                .required(Helpers.translation('email_input_require_error'));
        }

        if (index === 'password') {
            validationSchema['password'] = yup
                .string()
                .required(Helpers.translation('password_input_require_error'));
        }

        if (index === 'username') {
            validationSchema['username'] = yup
                .string()
                .min(5, ({ min }) => Helpers.translationParams('username_formik_yup_min_error', { min }))
                .max(28, ({ max }) => Helpers.translationParams('username_formik_yup_max_error', { max }))
                .matches(
                    /^[a-zA-Z0-9._-]+$/,
                    Helpers.translation('username_formik_yup_regex_error')
                )
                .required(Helpers.translation('cannot_be_left_blank'))
        }

        if (index === 'phone') {
            validationSchema['phone'] = yup
                .number()
                .typeError(Helpers.translation('phone_number_input_error_type'))
                .required(Helpers.translation('cannot_be_left_blank'));
        }

        if (index === 'date_time') {
            validationSchema['date_time'] = yup
                .string()
                .required(Helpers.translation('date_time_input_error_type'));
        }

        if (rules.indexOf(index) === -1) {
            validationSchema[index] = yup
                .string()
                .required(Helpers.translation('cannot_be_left_blank'));
        }

    })

    return yup.object().shape(validationSchema);
}

const exportHelpers = {
    createValidationSchema
}

export default exportHelpers;